module.exports = __webpack_public_path__ + "media/illustrations/glasses-8fa84137.png";